//export var  API_URL = "https://qrnode.shahbaz.hostingshouse.com/";
//export var  API_URL = "https://app.qrbuzz.mumara.com:8100/";
export var  API_URL = "https://app-qrbuzz.mumara.com/";
//export const  API_URL = "http://localhost:8000/";
